import { render } from "./FavoriteEvents.vue?vue&type=template&id=c8df6830"
import script from "./FavoriteEvents.vue?vue&type=script&lang=js"
export * from "./FavoriteEvents.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__